import {
  ClipboardIcon,
  ExportIcon,
  PlusCircleIcon,
  PaperclipIcon,
} from '@design-systems/react-icons'

export enum BACKGROUND_NOTIFICATIONS_CATEGORY {
  CREATE = 'CREATE',
  REQUEST = 'REQUEST',
  EXPORT = 'EXPORT',
  UPLOAD = 'UPLOAD',
  RELEASE = 'RELEASE',
}

export enum BACKGROUND_NOTIFICATIONS_TYPE {
  TECHPACK = 'TECHPACK',
  RELEASEPACK = 'RELEASE_PACKET',
  INSIGHTSEXPORT = 'INSIGHTS_EXPORT',
}

export const backgroundNotificationsConfig = {
  categories: [
    {
      name: BACKGROUND_NOTIFICATIONS_CATEGORY.CREATE,
      icon: PlusCircleIcon,
    },
    {
      name: BACKGROUND_NOTIFICATIONS_CATEGORY.REQUEST,
      icon: ClipboardIcon,
    },
    {
      name: BACKGROUND_NOTIFICATIONS_CATEGORY.EXPORT,
      icon: ExportIcon,
    },
    {
      name: BACKGROUND_NOTIFICATIONS_CATEGORY.UPLOAD,
      icon: PaperclipIcon,
    },
    {
      name: BACKGROUND_NOTIFICATIONS_CATEGORY.RELEASE,
      icon: ExportIcon,
    },
  ],
  types: [
    {
      name: BACKGROUND_NOTIFICATIONS_TYPE.TECHPACK,
      baseUrlOfAction: '/api/attachments',
      // TODO: add retryGqlQuery when the query is available in federated
      // retryGqlQuery: RETRY_TECHPACK,
    },
    {
      name: BACKGROUND_NOTIFICATIONS_TYPE.RELEASEPACK,
      baseUrlOfAction: '/api/attachments',
      // TODO: add retryGqlQuery when the query is available in federated
      // retryGqlQuery: RETRY_TECHPACK,
    },
    {
      name: BACKGROUND_NOTIFICATIONS_TYPE.INSIGHTSEXPORT,
      // Insights exports are served by a distinct backend (spark-insights-integration),
      // not the attachments file store - see /api/spark_insight_integration_exports
      // proxy config in nginx/extended-config/plm-api.conf.template.
      baseUrlOfAction: '/api/spark_insight_integration_exports',
    },
  ],
}
